// Email document scaffolding (doctype, head/CSS, outer table wrapper) for the
// brochure builder's complete-HTML output. Isolated here — like the webinar
// builder's email-template.ts — because the email-client CSS + MSO fallbacks
// need cross-client testing whenever they change.
//
// The document is a COMPLETE `<!DOCTYPE><html>…` — crm-api detects that and
// renders it verbatim (through the render-time XSS allowlist), adding no chrome
// of its own. The sections are appended between OPEN and CLOSE.

import { BROCHURE_COLORS } from './stock-images'

export const EMAIL_DOCUMENT_OPEN = `
<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title>Brochure</title>
  <!--[if gte mso 9]>
  <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
  </xml>
  <![endif]-->
  <style type="text/css">
    body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
    table { border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }
    @media only screen and (max-width: 620px) {
      .email-container { width: 100% !important; max-width: 100% !important; }
      .mobile-full { width: 100% !important; max-width: 100% !important; }
      /* Feature cards + showcase columns collapse to a single column on phones. */
      .mobile-stack { display: block !important; width: 100% !important; max-width: 100% !important; box-sizing: border-box !important; }
      .mobile-pad { padding-left: 24px !important; padding-right: 24px !important; }
      .mobile-center { text-align: center !important; }
      .mobile-gap { height: 16px !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background-color: ${BROCHURE_COLORS.soft}; font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: ${BROCHURE_COLORS.soft};">
    <tr>
      <td align="center" style="padding: 24px 0;">
        <table class="email-container" width="640" cellpadding="0" cellspacing="0" border="0" style="background-color: ${BROCHURE_COLORS.card}; max-width: 640px; width: 100%;">
`

export const EMAIL_DOCUMENT_CLOSE = `
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`
